import Vue from "vue";

const context = require.context("./", true, /.*\.vue/);
context.keys().forEach(filename => {
  const component = context(filename);
  if (component.default)
    Vue.component(component.default.name, component.default);
});
